import { Component, Input } from '@angular/core';
import { Pagination } from '@shared/pagination';
import { Job } from '@shared';

@Component({
  selector: 'mojo-reports-job-list-common',
  styleUrls: ['./reports-job-list-common.component.scss'],
  templateUrl: './reports-job-list-common.component.html',
})
export class ReportsJobListCommonComponent {
  @Input() innerTitle = true;
  @Input() jobTitle: string;
  @Input() allJobs: Pagination<Job>;
  @Input() leftColumnTitle: string;
  @Input() rightColumnTitle: string;
}
